export default () => (params) => {
  const searchParams = new URLSearchParams(window.location.search);

  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      searchParams.set(key, value);
    } else {
      searchParams.delete(key);
    }
  });

  window.history.replaceState(
    {},
    '',
    `${window.location.pathname}?${searchParams}${window.location.hash}`
  );
};
